// React Lib
import React, { useEffect, useState } from "react";
// Component Styles
import { useStyles } from "./EditDeviceLimitStyles";
// @otg-one/ui_components/components
import { Typography, DialogBox, Form, Button } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY, DeviceLimitType } from "../../constants";
import { StyledEngineProvider } from "@mui/material";
export const EditDeviceLimit = (props) => {
    const classes = useStyles(props);
    const { open, type, data, onClose, handleSubmitDeviceLimit, style, styleClient, textCancel, textChangeLimit, textConfirm, textEnterDeviceLimit, textClientTitle, textSystemDeviceLimitWarning, textSystemDeviceLimitClientWarning, textErrorMessageNull, textErrorMessageBelowZero, textErrorMessageClientLimit, textChange, textDeviceLimitText } = props;
    const [deviceLimit, setDeviceLimit] = useState(data.deviceLimit == null ? data.defaultDeviceLimit : data.deviceLimit);
    const [useClientLimit, setUseClientLimit] = useState(data.deviceLimit == null);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [confirmLowerDialogOpen, setConfirmLowerDialogOpen] = useState(false);
    useEffect(() => {
        setDeviceLimit(data.deviceLimit == null ? data.defaultDeviceLimit : data.deviceLimit);
        setUseClientLimit(data.deviceLimit == null);
    }, [open]);
    const handleCloseConfirmLowerDialog = () => {
        setConfirmLowerDialogOpen(false);
    };
    const handleChangeDeviceLimit = (e) => {
        setDeviceLimit(e.target.value === "" ? null : +e.target.value);
        setUseClientLimit(false);
        setIsError(false);
        setErrorMessage("");
    };
    const handleSubmit = () => {
        if (deviceLimit == null) {
            setIsError(true);
            setErrorMessage(textErrorMessageNull);
        }
        else if (deviceLimit < 0) {
            setIsError(true);
            setErrorMessage(textErrorMessageBelowZero);
        }
        else if (type === DeviceLimitType.SYSTEM && deviceLimit > data.defaultDeviceLimit) {
            setIsError(true);
            setErrorMessage(`${textErrorMessageClientLimit} ${data.defaultDeviceLimit}.`);
        }
        else if (type === DeviceLimitType.CLIENT && deviceLimit < data.deviceLimit) {
            setConfirmLowerDialogOpen(true);
        }
        else {
            handleConfirmSubmit();
        }
    };
    const handleConfirmSubmit = () => {
        data.deviceLimit = deviceLimit;
        handleSubmitDeviceLimit(data);
        setConfirmLowerDialogOpen(false);
        onClose();
    };
    return (React.createElement(StyledEngineProvider, { injectFirst: true },
        React.createElement(DialogBox, { open: open, handleClose: onClose, textTitle: `${textChange} ${type} ${textDeviceLimitText}`, style: style, maxWidth: "xs", content: React.createElement("div", { className: classes.editDeviceLimitDialogContainer },
                React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_ITALIC, size: 16, color: Color.neutral[900], className: classes.editDeviceLimitTypography }, data.textName),
                React.createElement(Form, { number: true, max: data.defaultDeviceLimit, min: 0, placeholder: textEnterDeviceLimit, value: deviceLimit, onChange: handleChangeDeviceLimit, error: isError, errorMessage: errorMessage, style: { width: 300 } }),
                useClientLimit && (React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_ITALIC, size: 14, color: Color.neutral[300], className: classes.editDeviceLimitTypography }, textSystemDeviceLimitWarning)),
                React.createElement("div", { className: classes.editDeviceLimitDialogActions },
                    React.createElement(Button, { type: "secondary", onClick: onClose, style: { marginLeft: 16, outline: 'none', marginRight: '25px' } }, textCancel),
                    React.createElement(Button, { style: { outline: 'none' }, disabled: isError, onClick: handleSubmit }, textChangeLimit))) }),
        type === DeviceLimitType.CLIENT && (React.createElement(DialogBox, { open: confirmLowerDialogOpen, handleClose: handleCloseConfirmLowerDialog, textTitle: textClientTitle, style: styleClient, content: React.createElement("div", { className: classes.editDeviceLimitDialogContainer },
                React.createElement(Typography, { fontFamily: FONT_FAMILY.CAPITOLIUM_ITALIC, size: 16, color: Color.neutral[900], className: classes.editDeviceLimitTypographyClient }, `${textSystemDeviceLimitClientWarning} ${deviceLimit}.`),
                React.createElement("div", { className: classes.editDeviceLimitDialogActions },
                    React.createElement(Button, { type: "secondary", style: { marginLeft: 16, outline: 'none', marginRight: '25px' }, onClick: handleCloseConfirmLowerDialog }, textCancel),
                    React.createElement(Button, { style: { outline: 'none' }, onClick: handleConfirmSubmit }, textConfirm))) }))));
};
EditDeviceLimit.defaultProps = {
    type: DeviceLimitType.CLIENT,
    data: {
        textName: "Data Name",
        deviceLimit: 20,
        defaultDeviceLimit: 25,
    },
    onClose: () => { },
    handleSubmitDeviceLimit: (data) => { },
    open: true,
    textCancel: "Cancel",
    textChangeLimit: "Change Limit",
    textConfirm: "Confirm",
    textEnterDeviceLimit: "Enter Device Limit",
    textChange: 'Change',
    textDeviceLimitText: 'Device Limit',
    textClientTitle: "Confirm Lowering Customer Device Limit?",
    textSystemDeviceLimitWarning: "System Device Limit is not set. Customer Device Limit is being used.",
    textSystemDeviceLimitClientWarning: "This will also lower the device limit of all systems that have set higher device limit than the new customer device limit ",
    textErrorMessageNull: "Limit cannot be empty",
    textErrorMessageBelowZero: "Limit cannot be below 0 (Zero)",
    textErrorMessageClientLimit: "Limit cannot be above Client's limit, which is "
};
export default React.memo(EditDeviceLimit);
